import React, { Component } from 'react';
import { Pie } from 'react-chartjs-2';
import { getValidationClass, getValidationClass_lvl2 } from '../components/UserFunctions'
//import NavbarCollapse from 'react-bootstrap/NavbarCollapse';
import PropTypes from 'prop-types';

class PieChart extends Component {
    state = {
        labels: ['TP', 'FP', 'FN'],
        datasets: [{
            data: [],
            backgroundColor: ['#CBFF68', '#E2E3FF', '#757af7']
        }],
        run_status: []
    }

    componentDidMount() {
        console.log(this.props)
        const param_json =  {bench_id:"empty",run_lim:this.props.run_lim}
          
            this.props.level === "2" ?
            
            getValidationClass_lvl2(param_json).then(res => {
                // console.log(res)
                if (res !== undefined) {
                    this.setState({

                        labels: ['TP', 'FP', 'FN'],
                        datasets: [{
                            data: [res.data.data[0], res.data.data[1], res.data.data[2]],
                            backgroundColor: ['#CBFF68', '#E2E3FF', '#757af7'],

                        }],
                        run_status: res.data.run_status
                    })
                }
            })
            :
            getValidationClass().then(res => {
                if (res !== undefined) {
                    this.setState({

                        labels: ['TP', 'FP', 'FN'],
                        datasets: [{
                            data: [res.data.data[0], res.data.data[1], res.data.data[2]],
                            backgroundColor: ['#CBFF68', '#E2E3FF', '#757af7'],

                        }],
                        run_status: res.data.run_status
                    })
                }
            })
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if ( this.props.level === "3" && newProps.run_id !== this.props.run_id) {
            var runid_json = { run_id: newProps.run_id }
            getValidationClass(runid_json).then(res => {
                // console.log(res.data);
                this.setState({

                    labels: ['TP', 'FP', 'FN'],
                    datasets: [{
                        data: [res.data.data[0], res.data.data[1], res.data.data[2]],
                        backgroundColor: ['#CBFF68', '#E2E3FF', '#757af7'],

                    }],
                    run_status: res.data.run_status

                })
            })
        }
        if (this.props.level === "2" && newProps.bench_id !== this.props.bench_id) {
            var benchid_json = { bench_id: newProps.bench_id, run_lim:newProps.run_lim }
            getValidationClass_lvl2(benchid_json).then(res => {
                // console.log(res.data);
                this.setState({

                    labels: ['TP', 'FP', 'FN'],
                    datasets: [{
                        data: [res.data.data[0], res.data.data[1], res.data.data[2]],
                        backgroundColor: ['#CBFF68', '#E2E3FF', '#757af7'],

                    }],
                    run_status: res.data.run_status

                })
            })
        }
    }
    render() {
        // console.log(this.state.run_status)
        return (
            <div data-test='dashboardChartsComponent'>
                {this.state.run_status !== undefined ?
                    <div>

                        <h1 style={{ color: "#464646" }}>Result: <span style={this.state.run_status === "FAIL" ? { color: "red" } : { color: "#428003" }}>{this.state.run_status}</span></h1>
                        <Pie
                            data={{
                                labels: this.state.labels,
                                datasets: this.state.datasets
                            }}
                            options={{
                                legend: {
                                    position: 'right',

                                }
                            }}

                        //   height='50%'
                        />
                &nbsp;
            </div>
                    : <div className="alert alert-secondary" role="alert">
                        No data available
              </div>
                }
            </div>
        )
    }
}
PieChart.propTypes={
level:PropTypes.string,
run_id:PropTypes.number,
bench_id:PropTypes.number,
run_lim:PropTypes.string,
//navigateHome:PropTypes.string,
}
PieChart.defaultProps= {
level:[],
run_id:1,
bench_id:1,
run_lim:[],
//navigateHome:[],
}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }
export default PieChart
